import { validate, reduceErrors, ValidationErrors } from "@util/validations"
import { makeAutoObservable } from "mobx"
import { GivenAnswerList } from "../lists/GivenAnswerList"
import { GivenAnswerProps } from "./GivenAnswer"

export interface QuestionnaireProps {
  id?: BigInt
  name?: string
  givenAnswers: GivenAnswerProps[]
  updatePath: string
}

export class Questionnaire {
  id?: BigInt
  name?: string
  givenAnswers: GivenAnswerList

  constructor(props: QuestionnaireProps) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.givenAnswers = new GivenAnswerList(props.givenAnswers)
    this.id = props.id
    this.name = props.name
  }
}

export function allQuestionsAnswered(questionnaire: Questionnaire): boolean {
  return questionnaire.givenAnswers.items.every((ga) => ga.hasBeenAnswered)
}

export function validateQuestionnaire(data: Questionnaire): ValidationErrors<Questionnaire> {
  return reduceErrors({
    givenAnswers: [validate(allQuestionsAnswered(data), "Please answer all the required questions")],
  })
}
